<template>
  <div class="flex flex-col sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-[520px]">
      <div
        v-if="!isRegistered"
        class="items-center bg-white px-6 md:px-12 pb-6 shadow sm:rounded-lg"
      >
        <SectionHeader
          class="mx-auto !justify-center pb-8 pt-14"
          :title="__('Register')"
        >
        </SectionHeader>
        <div>
          <div>
            <div class="pb-8">
              <div
                class="mx-auto flex w-full justify-center gap-2 rounded-lg bg-white"
              >
                  <button
                    class="w-full selected bg-[#F6F3F9] flex-1 rounded-md px-8 py-3 font-medium leading-normal text-zinc-800 outline-none transition-colors hover:bg-secondary/5`"
                    @click="redirectTo('candidateRegister')"
                  >
                    {{ __('Candidate') }}
                  </button>
                  <button
                    class="w-full bg-[#FAFAFA] flex-1 rounded-md px-8 py-3 font-medium leading-normal text-zinc-800 outline-none transition-colors hover:bg-secondary/5"
                    @click="redirectTo('companyRegister')"
                  >
                    {{ __('Company') }}
                  </button>
              </div>
            </div>
            <div>
              <div class="space-y-12">
                <form @submit.prevent="handleSubmit">
                  <div class="flex flex-col">
                    <InputEmail
                      id="password_current"
                      v-model:value="values.email"
                      v-model:errors="errors.email"
                      :label="__('Email')"
                      :placeholder="__('Your email')"
                      class="pb-4"
                      required
                    />

                    <InputPassword
                      id="password"
                      v-model:value="values.password"
                      v-model:errors="errors.password"
                      :label="__('Password')"
                      :placeholder="__('Choose your password')"
                      class="pb-4"
                      required
                    />
                    <div v-if="startTyping">
                      <div class="flex flex-row gap-2 pb-3">
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.min
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.min
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('min 8 characters') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.upper
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.upper
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one uppercase letter') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.lower
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.lower
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one lowercase letter') }}
                        </span>
                        </div>
                      </div>
                      <div class="flex flex-row gap-2 pb-4">
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.number
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.number
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one number') }}
                        </span>
                        </div>
                        <div class="flex items-center gap-1">
                          <Icon
                              :class="[
                            passwordRules.min === null
                              ? 'text-gray-400'
                              : passwordRules.special
                                ? 'text-green-600'
                                : 'text-red-600'
                          ]"
                              :name="
                            passwordRules.min === null || passwordRules.special
                              ? 'done'
                              : 'close'
                          "
                          />
                          <span class="text-xs text-zinc-600">
                          {{ __('one special character (@, #, $)') }}
                        </span>
                        </div>
                      </div>
                    </div>


                    <InputPassword
                      id="password_confirmation"
                      v-model:value="values.password_confirmation"
                      v-model:errors="errors.password_confirmation"
                      :label="__('Confirm your password')"
                      :placeholder="__('Rewrite your password')"
                      required
                      class="pb-8 md:col-start-2"
                    />
                    <div class="space-y-2 pb-8">
                      <InputCheckbox
                        id="recruit"
                        v-model:value="values.recruit"
                        v-model:errors="errors.recruit"
                        :label="__('I agree to the')"
                        class="mb-6"
                      >
                        <template #default>
                          <a :href="props.terms" target="_blank" class="text-black underline">{{
                            __('terms and conditions')
                          }}</a>
                          {{ __(' and the ') }}
                          <a :href="props.privacy" target="_blank" class="text-black underline">{{
                            __('privacy policy')
                          }}</a
                          >.
                        </template>
                      </InputCheckbox>

                      <InputCheckbox
                          id="marketing"
                          v-model:value="values.marketing"
                          v-model:errors="errors.marketing"
                          :label="__('I would like to receive news, updates and other marketing communications by email.')"
                          class="mb-6"
                      />


                    </div>
                    <div v-if="errorMessage"
                        class="flex items-center gap-1 rounded-lg border border-red-400 bg-red-100 p-4 text-red-700 mb-4">
                        <span
                            class="material-symbols-outlined text-xl text-red-600"
                            style="font-variation-settings: 'FILL' 1"
                        >
                          error
                        </span>
                      <span>{{ errorMessage }}</span>
                    </div>
                    <div class="text-center">
                      <p class="text-sm">
                        {{ __('Already have an account?')}}
                        <a @click="redirectTo('login')" class="font-medium text-primary cursor-pointer">{{ __('Sign In')}}</a>
                      </p>
                    </div>
                  </div>

                  <div
                    class="mt-4 flex flex-col gap-2 md:flex-row-reverse md:justify-center items-center"
                  >
                    <Button
                      class="flex items-center justify-center gap-1.5"
                      :type="isLoading ? 'button' : 'submit'"
                      :disabled="isLoading"
                      style="width: 10rem !important"
                    >
                      <Icon
                        v-if="isLoading"
                        class="animate-spin text-lg"
                        name="progress_activity"
                      />
                      <span>{{ __('Sign Up') }}</span>
                    </Button>
                  </div>
                  <div class="flex flex-col">
                    <SocialLoginButton></SocialLoginButton>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="flex flex-col items-center bg-white px-20 text-center shadow sm:rounded-lg"
      >
        <img
          src="/images/front/verify-account.png"
          class="h-44 w-44 mt-20"
          alt="Jobful"
        />

        <h2 class="mt-4 text-2xl font-bold text-gray-900">
          {{ __('Your account was created. Please verify your email to confirm your account.') }}
        </h2>

        <p class="mt-4 text-sm text-gray-600">
          {{__('The confirmation code was sent to your email')}}
          <strong>{{ maskedEmail(successMessage.email) }}</strong>
        </p>

        <a @click="redirectTo('login')"
           class="mt-8 mb-14 text- text-zinc-800 cursor-pointer flex items-center gap-2">
          <img src="/images/front/arrow_back.png" alt="Back Arrow" class="w-4 h-4" />
          {{ __('Back to login') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { Button } from '../../../../components/block/button';
  import { Icon } from '../../../../components/block/icon';
  import { InputPassword } from '../../../../components/form/input-password';
  import { InputEmail } from '../../../../components/form/input-email';
  import { SectionHeader } from '../../../components/section-header';
  import { InputCheckbox } from '../../../../components/form/input-checkbox';
  import axios from 'axios';
  import SocialLoginButton from '../components/SocialLoginButton.vue';

  const toast = useToast();
  const isRegistered = ref(false);
  const successMessage = ref(null);
  const startTyping = ref(false);

  const props = defineProps({
    terms: String,
    privacy: String,
    referral: String,
    companyName: String,
  });

  const values = ref({
    email: '',
    password: '',
    password_confirmation: '',
    recruit: false,
    marketing: false,
    referral: '',
  });

  const errors = ref({
    email: [],
    password: [],
    password_confirmation: [],
    recruit: []
  });

  const isLoading = ref(false);
  const errorMessage = ref('');

  const passwordRules = ref({
    min: null,
    upper: null,
    lower: null,
    number: null,
    special: null
  });

  const routes = {
    companyRegister: 'front.auth.company.register',
    candidateRegister: 'front.auth.register',
    login: "login.user",
  }

  const redirectTo = (routeName) => {
    window.location.href = route(routes[routeName]);
  }

  onMounted(() => {
    if (props.referral) {
      values.value.referral = props.referral;
    }
  });

  watch(
      [() => values.value.password, () => values.value.password_confirmation],
      ([newPassword, confirmPassword]) => {
        if (newPassword.length > 0) {
          startTyping.value = true;
        }

        if (newPassword.length === 0) {
          startTyping.value = false;
        }

        passwordRules.value.min = newPassword.length === 0 ? null : newPassword.length >= 8;
        passwordRules.value.upper = newPassword.length === 0 ? null : /[A-Z]/.test(newPassword);
        passwordRules.value.lower = newPassword.length === 0 ? null : /[a-z]/.test(newPassword);
        passwordRules.value.number = newPassword.length === 0 ? null : /\d/.test(newPassword);
        passwordRules.value.special = newPassword.length === 0 ? null : /[^a-zA-Z0-9]/.test(newPassword);

        if (confirmPassword && newPassword !== confirmPassword) {
          errors.value.password_confirmation = [
            __('Your new password must match the confirmation password')
          ];
        } else {
          errors.value.password_confirmation = [];
        }
      }
  );

  const maskedEmail = (email) => {
    if (!email) return '';
    const [name, domain] = email.split('@');
    return `${name[0]}****${name.slice(-1)}@${domain}`;
  };

  async function handleSubmit() {
    const requiredFieldKeys = [
      'email',
      'password',
      'password_confirmation',
      'recruit'
    ];
    let firstElement;

    requiredFieldKeys.forEach((key) => {
      if (!values.value[key]) {
        errors.value[key] = [__('This field is required')];

        const element = document.getElementById(key);

        if (element && !firstElement) {
          firstElement = element;
        }
      }
    });

    if (!values.value.recruit) {
      errors.value.recruit = [__('You must agree to the terms and conditions.')];
    }

    if (values.value.password !== values.value.password_confirmation) {
      errors.value.password_confirmation = [
        __('Your new password must match the confirmation password')
      ];
    }

    if (Object.values(errors.value).some((error) => error.length)) {
      if (firstElement) {
        firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    isLoading.value = true;
    successMessage.value = null;
    errorMessage.value = null;

    try {
      const apiUrl = '/register';
      const response = await axios.post(apiUrl, values.value);

      if (response?.data?.status === 'success') {
        isRegistered.value = true;
        successMessage.value = { email: values.value.email };
        errorMessage.value = '';
      } else {
        errorMessage.value = __('An unexpected error has occurred. Please try again.');
      }
    } catch (error) {
      if (error?.response?.data?.message && error?.response?.data?.status === 'error') {
        errorMessage.value = error.response?.data?.message ||  __('Something went wrong.');
        successMessage.value = '';
      } else {
        errorMessage.value = __('An unexpected error has occurred. Please try again later.');
      }
    }

    isLoading.value = false;
  }
</script>
